export default __webpack_public_path__ + "static/Team_Member_ANNBEL-f061e477e9ecdeac02142ff392b0de09.png";